import {push} from 'notivue';

export function notifyError(message) {


    if (typeof message === 'string') {
        push.error({
            title: 'Erro!',
            message,
            duration: 5000
        })
    } else if(message.status) {
        if (message.status === 422) {
            let m = message.data
            const keys = Object.keys(m);
            let data = '';

            keys.forEach(key => {
                data += `${m[key]}\n`;
            })

            push.error({
                title: 'Erro!',
                message: data,
                duration: 5000
            })
        } else if (message.status === 500) {
            push.error({
                title: 'Erro!',
                message: message.data.message,
                duration: 5000
            })
        }
    }
}

export function notifySuccess(message) {
    push.success({
        title: 'Sucesso!',
        message,
        duration: 5000
    })
}

export function getMessageError(data) {
    const keys = Object.keys(data);
    notifyError(data[keys[0]][0]);
}
